import React from 'react';

import { color, label, meaning, normalize } from './index';

/**
 * A severity, drawn the same way on every page: the platform colour (low is blue; green is only
 * for clean), the platform label, and the level's meaning on hover.
 *
 * `unknown` (not graded) renders an em dash, never a guessed level; `none` renders "None".
 * `text` replaces the label only (a translated one); the level and colour stay the platform's.
 */
export default function SeverityChip({ severity, title = null, className = '', text = null }) {
  const lv = normalize(severity);
  if (lv === 'unknown') {
    return (
      <span className={`text-muted ${className}`.trim()} title={title || 'Not graded'}
        aria-label="Severity: not graded" data-severity="unknown">—</span>
    );
  }
  const c = color(lv);
  const { meaning: what, response } = meaning(lv);
  return (
    <span
      className={`sev-chip ${className}`.trim()}
      data-severity={lv}
      title={title || [what, response].filter(Boolean).join(' ')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '1px 8px',
        borderRadius: 999,
        border: `1px solid ${c}66`,
        background: `${c}1a`,
        color: c,
        fontSize: 11.5,
        fontWeight: 600,
        lineHeight: '18px',
        whiteSpace: 'nowrap',
      }}
    >
      {text || label(lv)}
    </span>
  );
}
